declare const REACT_APP_REDIRECT_URI: string;
declare const REACT_AUTHO_DOMAIN: string;
declare const REACT_AUTHO_CLIENT_ID: string;
declare const REACT_AUTHO_AUDIENCE: string;

export const authConfig = {
  domain: REACT_AUTHO_DOMAIN,
  clientId: REACT_AUTHO_CLIENT_ID,
  redirectUri: REACT_APP_REDIRECT_URI,
  audience: REACT_AUTHO_AUDIENCE,
  scope: 'openid profile email',
};